import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Gallery } from "../../components/gallery/gallery";

import bgStreamingContent from "../../assets/imgs/servicios/marketing//marketing.jpg";
import bgStreaming from "../../assets/imgs/servicios/marketing/bg_mk_head.png";
import { useTranslation } from "react-i18next";
import { SubservicesTabs } from "../../components/subservicesTabs/subservicesTabs";

import ico01 from "../../assets/imgs/servicios/marketing/mk01.jpg";
import ico02 from "../../assets/imgs/servicios/marketing/mk02.jpg";
import ico03 from "../../assets/imgs/servicios/marketing/mk03.jpg";
import ico04 from "../../assets/imgs/servicios/marketing/mk04.jpg";
import ico05 from "../../assets/imgs/servicios/marketing/mk05.jpg";
import ico06 from "../../assets/imgs/servicios/marketing/mk06.jpg";
export const galleryMarketing = [ico01, ico02, ico03, ico04, ico05, ico06];

export const MarketingPage = () => {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };
    scrollToTop();
  });
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Marketing y Redes Sociales - JC Innovation</title>
      </Helmet>
      <section className="wrapper__page_services">
        <div className="contain__head_page">
          <div className="container-lg">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="sec_head container_am">
                  <h3 className="ttls ttl_section c_morado mb-4">
                    {t("Marketing y Redes Sociales")}
                  </h3>
                  <p className="paragraph lg">
                    {t(
                      "En JC Innovation sabemos que un congreso o evento no solo se vive en el lugar, sino también en el mundo digital. Por eso, diseñamos estrategias de marketing y redes sociales que generan expectativa, aumentan la asistencia y extienden la experiencia de tu evento más allá del día de cierre"
                    )}
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="text-center">
                  <img src={bgStreaming} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="contain_info__page ">
          <div className="container_am">
            <div className="text-center">
              <h3 className="ttls ttl_section mb-2">
                {t("¿Qué hacemos en Marketing y redes sociales?")}
              </h3>
              <p className="paragraph lg">
                {t(
                  "Nos encargamos de llevar a cabo la producción correspondiente en materia de publicidad. "
                )}
              </p>
            </div>
          </div>
          <div className="container-lg">
            <div className="row">
              <div className="col-md-4">
                <div className="col_info">
                  <h3 className="fw_600 mb-4 c_morado">
                    {t("Planeación de estrategia digital")}
                  </h3>
                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t(
                      "Calendarios de publicaciones (parrillas). Contenido programado que informa, emociona y atrae asistentes."
                    )}
                  </p>
                  <hr />
                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t(
                      " Aumentamos la tasa de cierres de tu equipo de vendedores con la ayuda de software, datos y metodologías probadas para ello."
                    )}
                  </p>
                  <hr />

                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t("Cobertura en vivo. Publicaciones, historias y reels. ")}
                  </p>
                  <hr />

                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t(
                      "Gestión de comunidad. Monitoreo de comentarios, mensajes y reacciones para reforzar la cercanía. "
                    )}
                  </p>
                  <hr />

                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t(
                      "Campañas de difusión. Segmentación de público con campañas pagadas en Facebook e Instagram. "
                    )}
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                {" "}
                <div className="con_img_info">
                  <img src={bgStreamingContent} alt="Streaming" />
                </div>
              </div>
              <div className="col-md-4">
                {" "}
                <div className="col_info">
                  <h3 className="fw_600 mb-4 c_morado">{t("Beneficios")}</h3>
                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t("Posicionamiento digital profesional de tu evento.")}
                  </p>
                  <hr />

                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t("Tu proceso de ventas es largo y complicado.")}
                  </p>
                  <hr />

                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t("Mayor alcance y visibilidad antes, durante y después.")}
                  </p>
                  <hr />

                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t("Interacción activa con los asistentes en tiempo real.")}
                  </p>

                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t(
                      "Contenido que sigue generando valor incluso después del congreso."
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SubservicesTabs />
        <Gallery images={galleryMarketing} title="Marketing" />
      </section>
    </>
  );
};
